import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { FunctionDto, AccountableFunctionDto } from '@cradua/data';

@Component({
  selector: 'cradua-accountablefunction',
  templateUrl: './accountablefunction.component.html',
  styleUrls: ['./accountablefunction.component.scss'],
})
export class AccountablefunctionComponent implements OnInit {
  [x: string]: any;
  @Input() accountableFunctions: AccountableFunctionDto[];
  @Input() functions: FunctionDto[];
  accountablefunctionForm: FormGroup;
  accountablefunctionFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<AccountableFunctionDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  // SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  // selectedFunction: any;

  filteredDelete: Array<any> = [];
  filteredAccountableFunction: Array<any> = [];
  status: boolean;
  selectedFunctionId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.createAccountablefunctionForm();
  }

  createAccountablefunctionForm() {
    this.accountablefunctionFormArray = this.fb.group({
      AccountableFunctions: this.fb.array([]),
    });
    this.accountablefunctionForm = this.fb.group({
      AccountableFunctionName: ['', Validators.required],
      FunctionId: this.selectedFunctionId,
      FunctionalEmail: [''],
      TeamLead: [''],
      id: null,
    });
  }

  // method to display functions
  setAccountableFunction() {
    const control = this.accountablefunctionFormArray.controls
      .AccountableFunctions as FormArray;
    this.filteredAccountableFunction.forEach((e) => {
      control.push(
        this.fb.group({
          AccountableFunctionName: e.AccountableFunctionName,
          FunctionId: e.FunctionId,
          FunctionalEmail: e.FunctionalEmail,
          TeamLead: e.TeamLead,
          id: e.id,
        })
      );
    });
  }

  //method to add functions
  addAccountableFunction(accountablefunction: AccountableFunctionDto) {
    console.log('AccountableFunction');
    const control = this.accountablefunctionFormArray.controls
      .AccountableFunctions as FormArray;
    control.insert(
      0,
      this.fb.group({
        AccountableFunctionName: accountablefunction.AccountableFunctionName,
        FunctionalEmail: accountablefunction.FunctionalEmail,
        TeamLead: accountablefunction.TeamLead,
        FunctionId: this.selectedFunctionId,
      })
    );
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.accountablefunctionFormArray.controls
      .AccountableFunctions as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter accountablefunction
  selectFunction(event: string) {
    this.filteredAccountableFunction = this.accountableFunctions.filter(
      (s) => s.FunctionId === event
    );
    this.selectedFunctionId = event;
    const control = this.accountablefunctionFormArray.controls
      .AccountableFunctions as FormArray;

    if (this.filteredAccountableFunction.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setAccountableFunction();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete function from arrary list
  deleteAccountableFunction(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.accountablefunctionFormArray.controls
          .AccountableFunctions as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.accountableFunctions.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.accountableFunctions[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }
  addNew(formValue: AccountableFunctionDto) {
    if (this.accountablefunctionForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.accountablefunctionFormArray
        .get('AccountableFunctions')
        ['controls'][this.selectedIndex].patchValue({
          AccountableFunctionName: formValue.AccountableFunctionName,
          FunctionalEmail: formValue.FunctionalEmail,
          TeamLead: formValue.TeamLead,
        });
    } else {
      this.addAccountableFunction(formValue);
    }
    this.selectedIndex = null;
    this.accountablefunctionForm.reset();
  }

  onEdit(index, value: AccountableFunctionDto) {
    this.selectedIndex = index;
    this.accountablefunctionForm.patchValue({
      AccountableFunctionName: value.AccountableFunctionName,
      FunctionalEmail: value.FunctionalEmail,
      TeamLead: value.TeamLead,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.accountablefunctionForm.reset();
  }

  onSubmit(formValue: any) {
    console.log('submit', formValue);
    formValue.type = 'accountablefunction';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('accountablefunction');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
